// import '@/assets/scss/app.scss';
import reportWebVitals from '@/config/reportWebVitals';
import { Router } from '@/lib/router-dom';
import store from '@/redux/store.js';
import axios from 'axios';
import React from 'react';
import { initResizeObserverErrorHandler } from './utils/resize-observer-error-handler';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';

axios.defaults.headers.common['Channel'] = 'UI';

// Initialize the ResizeObserver error handler to suppress loop errors
initResizeObserverErrorHandler();

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <Router>
                <App />
            </Router>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

reportWebVitals();
